<template>
  <div class="folder-data">
    <div
      v-if="errorFolders"
      class="text-gray-700 text-base p-4 border-t border-gray-400"
    >
      Si è verificato un errore
    </div>

    <!-- No Errors -->
    <template v-if="!errorFolders">
      <template v-if="loadingFolders">
        <div class="text-gray-700 text-base p-4 border-t border-gray-400">
          Caricamento...
        </div>
      </template>
      <!-- No Loading -->
      <template v-else>
        <FolderItemsList
          v-if="contentPresent"
          :folders="foldersByParent.data"
          :podcasts="findFolderByID.podcasts.data"
          :select-all="selectAll"
        />
        <!-- No result -->
        <div
          v-else
          class="text-gray-700 text-base p-4 border-t border-gray-400"
        >
          Nessun contenuto in questa cartella
        </div>
      </template>

      <Modal ref="moveToFolderModal">
        <MoveToFolder @move="moveToFolder" />
      </Modal>
    </template>
  </div>
</template>

<script>
/** graphql */
import GET_FOLDER_DATA from '@/graphql/GetFolderData.gql'

/** Components */
import FolderItemsList from '@/components/FolderItemsList.vue'
import MoveToFolder from '@/components/MoveToFolder.vue'
import Modal from '@/components/Modal.vue'

import { deleteAllQuery, moveToFolderQuery } from '@/lib/folders'

export default {
  components: {
    FolderItemsList,
    MoveToFolder,
    Modal,
  },

  props: {
    folderId: {
      type: String,
      required: true,
    },

    folderLoading: {
      type: Boolean,
      default: true,
    },

    folderError: {
      type: Boolean,
      default: false,
    },

    folderNotfound: {
      type: Boolean,
      default: false,
    },

    selectAll: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      query: GET_FOLDER_DATA,
      findFolderByID: {},
      foldersByParent: {},
      loadingFolders: true,
      errorFolders: false,
      contentPresent: false,
    }
  },
  apollo: {
    folderDataPodcast: {
      query: GET_FOLDER_DATA,
      manual: true,
      variables() {
        return {
          id: this.folderId,
        }
      },
      result({ data, loading, error }) {
        if (error) {
          this.errorFolders = true
        }
        if (!loading && data.findFolderByID && data.foldersByParent) {
          this.findFolderByID = data.findFolderByID
          this.foldersByParent = data.foldersByParent
          const amountContent =
            this.findFolderByID.podcasts.data.length +
            this.foldersByParent.data.length
          this.contentPresent = amountContent > 0
          this.loadingFolders = false
        }
      },
    },
  },

  methods: {
    async reloadFolder() {
      this.errorFolders = false
      this.errorFolders = false
      this.$apollo.queries.folderDataPodcast.refetch()
    },
    async deleteChecked() {
      const query = deleteAllQuery(
        this.$store.state.folders.checkedFolders,
        this.$store.state.folders.checkedPodcasts,
      )

      await this.$apollo.mutate({
        ...query,
      })

      await this.reloadFolder()
    },

    openMoveToFolder() {
      this.$refs.moveToFolderModal.open()
    },

    async moveToFolder(targetId) {
      const query = moveToFolderQuery(
        this.$store.state.folders.checkedFolders,
        this.$store.state.folders.checkedPodcasts,
        targetId,
      )

      await this.$apollo.mutate({
        ...query,
      })

      this.$refs.moveToFolderModal.close()

      await this.reloadFolder()
    },
  },
}
</script>

<style lang="scss" scoped>
.folder-data {
  @include e(item) {
    @apply border-t border-solid border-gray-400;
  }
}
</style>
